import React from 'react';
import PropTypes from 'prop-types';
import { Card as AntCard } from 'antd';
import Card from '../../../core/layout/Card';
import GaugeChart from '../../../core/chart/GaugeChart';
import Button from '../../../core/form/Button';
import { isNil } from 'lodash';

const { Meta } = AntCard;

const KpiChart = (props) => {
  return (
    <Card
      title={props.title}
      loading={props.loading}
      style={{
        height: 450,
      }}
      actions={
        props.onClickHistory && <Button label="History" onClick={props.onClickHistory} type="primary" size="sm" />
      }
    >
      <Meta description={props.description} style={{ height: 185, position: 'relative', zIndex: 2 }} />
      <GaugeChart
        value={props.currentValue}
        intervals={props.intervals}
        stepSize={props.stepSize}
        reverseColors={props.reverseColors}
        rules={props.colorRules}
      />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span
          style={{
            fontSize: '18px',
            color: '#000',
            marginRight: '30px',
            fontWeight: 'bold',
          }}
        >
          {props.formatter(props.currentValue)}
        </span>
        {!isNil(props.previousValue) && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              fontSize: '12px',
              lineHeight: '16px',
              justifyContent: 'center',
            }}
          >
            <span>Previous</span>
            <span>{props.formatter(props.previousValue)}</span>
          </div>
        )}
      </div>
    </Card>
  );
};

KpiChart.propTypes = {
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  currentValue: PropTypes.number.isRequired,
  stepSize: PropTypes.number.isRequired,
  previousValue: PropTypes.number,
  intervals: PropTypes.array,
  reverseColors: PropTypes.bool,
  formatter: PropTypes.func,
  onClickHistory: PropTypes.func.isRequired,
  colorRules: PropTypes.arrayOf(
    PropTypes.shape({
      rule: PropTypes.string.isRequired,
      backgroundColor: PropTypes.string.isRequired,
    })
  ),
};

KpiChart.defaultProps = {
  previousValue: null,
  title: null,
  description: null,
  reverseColors: false,
  formatter: (value) => value,
};

export default KpiChart;
